import React from 'react';
import SuppliersListFunctional from './components/suppliers-list-functional';

const SuppliersList = () => {
	return <SuppliersListFunctional />;
};

export default SuppliersList;
